import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/lang'
import elementui from '@/elementui'
import fontawesome from '@/fontawesome'
//import dajs from '@/dayjs'
import dayjsPlugin from '@/dayjs';

import '@/assets/libs/bootstrap/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/assets/css/tooltip.css'

import {Plugin} from 'vue-fragment'
import UUID from 'vue-uuid'
import VueTheMask from 'vue-the-mask'
import VTooltip from 'v-tooltip'

// const VueUploadComponent = require('vue-upload-component')
// Vue.component('file-upload', VueUploadComponent)

Vue.use(dayjsPlugin);
Vue.use(VTooltip)
Vue.use(VueTheMask)
Vue.use(Plugin)
Vue.use(UUID)
Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
}).$mount('#app')
